/**
 * Module definition for documentation module. The documentation module manages
 * the application's top-level documentation view (i.e., /documentation).
 *
 * @module routes.documentation
 */

angular.module('routes.documentation', [
  'stack',
  'routes.documentation.constants',
  'routes.documentation.DocumentationController'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.documentation', {
          url: '/documentation',
          templateUrl: 'js/routes/documentation/documentation.html',
          controller: 'DocumentationController',
          resolve: {
            constants: [
              'ConstantResolver',
              'DOCUMENTATION',
              function (ConstantResolver, DOCUMENTATION) {
                return new ConstantResolver(DOCUMENTATION);
              }
            ],
            translate: [
              'TranslationResolver',
              function (TranslationResolver) {
                return new TranslationResolver();
              }
            ]
          }
        }
      );
    }
  ]
);
